import React from 'react';
import { Link } from 'react-router-dom';
import { Input, Divider, Spin, Col, Row, Button, Modal } from 'antd';

import { compose } from '../../core';
import { getIntFromString, ReactMarkdown, CardLayout, RenderTableWithLayout, TeamEmployeeField } from '../../look';
import { IMG } from '../../../config';
import ROUTE from '../route';

import {
  withOrganizationState,
  withOrganizationFilterUpdating,
  /* withTeam, */ withTeamByTeamId,
  withDeleteTeam,
  withEditTeam
} from './OrganizationOperation';

const TeamDetail = props => {
  const { history, editTeam, loading, teamByTeamId, deleteTeam, onFiltersRemove } = props;
  const [employee, setEmployee] = React.useState(false);

  const handleEmployeeSubmit = async employees => {
    try {
      await editTeam({ id: getIntFromString(teamByTeamId.id), employees, name: teamByTeamId.name });
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return (
    <CardLayout
      active={ROUTE.team}
      title={[
        {
          name: `${teamByTeamId?.vertical?.organization?.name || ''}`,
          link: `${ROUTE.organizationDetailLink}${
            teamByTeamId &&
            teamByTeamId.vertical &&
            teamByTeamId.vertical.organization &&
            getIntFromString(teamByTeamId.vertical.organization.id)
          }`
        },
        {
          name: `${teamByTeamId?.vertical?.name || ''}`,
          link: `${ROUTE.verticalDetailLink}${
            teamByTeamId && teamByTeamId.vertical && getIntFromString(teamByTeamId.vertical.id)
          }`
        },
        {
          name: `${teamByTeamId?.name || ''}`,
          link: `${ROUTE.teamDetailLink}${teamByTeamId && getIntFromString(teamByTeamId.id)}`
        }
      ]}
      showTitle={false}
      editLink={ROUTE.editTeamLink}
      addLink={ROUTE.addTeam}
      backLink={`${ROUTE.verticalDetailLink}${
        teamByTeamId && teamByTeamId.vertical && getIntFromString(teamByTeamId.vertical.id)
      }`}
      onFiltersRemove={onFiltersRemove}
      table={false}
      onDelete={() => {
        deleteTeam(getIntFromString(teamByTeamId.id));
        history.push(
          `${ROUTE.verticalDetailLink}${teamByTeamId && teamByTeamId.vertical && getIntFromString(teamByTeamId.vertical.id)}`
        );
      }}
      rowKey={teamByTeamId && teamByTeamId.id}
    >
      <Row>
        <Col span={23}>
          <Spin spinning={loading} size="large">
            <div style={{ minHeight: '70vh' }}>
              {teamByTeamId && (
                <>
                  <Row gutter={[24, 24]}>
                    <Col span={12}>
                      <Row>
                        <Button type="primary" ghost onClick={() => setEmployee(true)}>
                          <Link>Add /Edit Employees</Link>
                        </Button>
                      </Row>
                      <br />
                      <Row
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'baseline'
                        }}
                      >
                        <h3 style={{ marginBottom: 0, fontWeight: 'normal' }}>Description</h3>
                        {/* <Button type="link">Edit</Button> */}
                      </Row>
                      <div
                        style={{
                          border: '1px solid rgba(202, 202, 202, 0.25)',
                          margin: '7px',
                          padding: '15px',
                          minHeight: '140px',
                          borderRadius: '2px'
                        }}
                      >
                        <ReactMarkdown>{teamByTeamId.description}</ReactMarkdown>
                      </div>
                    </Col>
                    <Col span={1}>
                      <Divider type="vertical" style={{ height: '100%' }} />
                    </Col>
                    <Col span={11}>
                      <Row justify="space-between">
                        <Col>
                          <h3>Manager</h3>
                        </Col>
                        {/* <Col>
                        <Button type="link">Edit</Button>
                      </Col> */}
                      </Row>

                      {teamByTeamId?.managers?.edges?.map(({ node }) => (
                        <Row gutter={[24, 24]}>
                          <Col>
                            <img
                              src={IMG}
                              alt=""
                              style={{
                                width: 70,
                                height: 80,
                                backgroundColor: '#f3f3f3'
                              }}
                            />
                          </Col>
                          <Col>
                            <h4 style={{ marginBottom: 0, fontWeight: 'normal' }}>Name</h4>
                            <h4
                              style={{
                                marginBottom: 0,
                                fontWeight: 'normal',
                                color: '#898A82'
                              }}
                            >
                              {`${node?.user?.firstName} ${node?.user?.lastName}`}
                            </h4>
                            <h4 style={{ marginBottom: 0, fontWeight: 'normal' }}>Email</h4>
                            <h4
                              style={{
                                marginBottom: 0,
                                fontWeight: 'normal',
                                color: '#898A82'
                              }}
                            >
                              {node?.user?.email}
                            </h4>
                          </Col>
                        </Row>
                      ))}
                      <br />
                    </Col>
                  </Row>
                  <Row>
                    <Divider style={{ width: '100%' }} />
                  </Row>
                  <br />
                  <Row gutter={[24, 24]}>
                    {teamByTeamId &&
                      teamByTeamId.employees.edges.map(({ node }) => (
                        <Col>
                          <img src={IMG} alt="" style={{ width: 48, borderRadius: 30, marginRight: 10 }} />{' '}
                          {`${node.user.firstName} ${node.user.lastName}`}
                        </Col>
                      ))}
                  </Row>
                </>
              )}
            </div>
          </Spin>
        </Col>
      </Row>

      <Modal
        destroyOnClose
        visible={employee}
        onCancel={() => setEmployee(false)}
        footer={null}
        title="Employee"
        width="25%"
        bodyStyle={{ padding: 12 }}
      >
        <Row>
          {teamByTeamId && teamByTeamId.employees && (
            <TeamEmployeeField
              verId={getIntFromString(teamByTeamId?.vertical?.id)}
              initialValues={teamByTeamId.employees}
              handleSubmit={handleEmployeeSubmit}
            />
          )}
        </Row>
        <br />

        {teamByTeamId &&
          teamByTeamId.employees &&
          teamByTeamId.employees.edgeCount > 0 &&
          teamByTeamId.employees.edges.map(({ node }) => (
            <Row
              justify="space-between"
              style={{
                paddingTop: 10,
                display: 'block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              <img src={IMG} alt="" style={{ width: 48, borderRadius: 30, marginRight: 10 }} />{' '}
              {`${node.user.firstName} ${node.user.lastName}`}
            </Row>
          ))}
      </Modal>
    </CardLayout>
  );
};

export default compose(
  withOrganizationState,
  // withTeam,
  withDeleteTeam,
  withTeamByTeamId,
  withOrganizationFilterUpdating,
  withEditTeam
)(TeamDetail);
